import * as React from 'react';
import { createSvgIcon } from '..';
export var Menu = createSvgIcon({
    LeftToRight: (React.createElement(React.Fragment, null,
        React.createElement("circle", { cx: "2", cy: "8", r: "1", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("circle", { cx: "8", cy: "8", r: "1", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("circle", { cx: "14", cy: "8", r: "1", stroke: "currentColor", strokeWidth: "2" }))),
}, 'small');
//# sourceMappingURL=Menu.js.map